// src/config/environment.js

const env = process.env.REACT_APP_ENV || 'production';
const hostname = window.location.hostname;

// Get the hostnames for each environment from environment variables
const devHosts = process.env.REACT_APP_DEV_HOSTS ? process.env.REACT_APP_DEV_HOSTS.split(',') : [];
const prodHosts = process.env.REACT_APP_PROD_HOSTS ? process.env.REACT_APP_PROD_HOSTS.split(',') : [];

const config = {
  dev: {
    websiteUrl: 'https://dev.aiguru.pro', // Default dev URL; can be changed if needed
  },
  production: {
    websiteUrl: 'https://goaiguru.com', // Default production URL; can be changed if needed
  },
};

// Determine environment based on the hostname
const environment = prodHosts.includes(hostname) ? 'production' : 'dev';

export default config[environment];
